import { render } from "./ListeChampsLibreFamille.vue?vue&type=template&id=4ab5a58e&ts=true"
import script from "./ListeChampsLibreFamille.vue?vue&type=script&lang=ts"
export * from "./ListeChampsLibreFamille.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__